import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  InputAdornment,
  Divider,
  Button,
  Typography,
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  Paper,
  TextField,
  TableRow,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableBody,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PerfectScrollbar from "react-perfect-scrollbar";
import clsx from "clsx";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { appService } from "../../App/app.service";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Skeleton from "@material-ui/lab/Skeleton";
import { styles } from "../../EnhancedInsights/NewFunnel/FunnelStyles";
import Loading from "../../components/Loading";
import * as d3 from "d3";
import NumberFormat from "react-number-format";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import {
  _isNaN,
  getDefaultSelectedFiscalQuarters,
  getDefaultACV,
  dateFormatterMomentV4,
  getDefaultThreshold,
  getDefaultSalesType,
  countOrACVFormatter,
  getDefaultSelectedProductFamily,
} from "../../util/customFunctions";
import Drilldown from "../../components/Drilldown/Drilldown";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import PipelineTable from "./PipelineTable";
import LowMIdHighTable from "./LowMidHighTable";
import DeviationTable from "./DeviationTable";
import NextQuarterConversionTable from "./NextQuarterConversionTable";
import ExpectedLowMidHighTable from "./ExpectedLowMidHighTable";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";
import EnsembleModelTable from "./EnsembleModelTable";
// import addHeaderdescription from "../../components/HeaderDescription";
import PipelineTablev2 from "./PipelineTablev2";
import VerticalStackedBarChart from "../../components/D3Components/D3VerticalStackedBar";
import TeamFilterHierarchy from "../../components/team-filter-hirarchy";
import AccountEmpRangeFilter from "../../components/AccountEmpRangeFilterComponent";
import AccountTypeFilter from "../../components/AccountTypeFilterComponent";
import RegionFilter from "../../components/RegionFilterComponent";
import OppSourceChannelFilterComponent from "../../components/OppSourceChannelFilterComponent";
import ChannelTypeFilterComponent from "../../components/ChannelTypeFilterComponent";
import TransactionTypeFilter from "../../components/TransactionTypeFilterCOmponent";
import ExportPPtx from "../../components/ExportPPT";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
import AdditionalQualifiedPipelineNeeded from "./AdditionalQualifiedPipelineNeeded";
import VerticalStackedBarChartWithoutQuota from "../../components/D3Components/D3VertcalStackedBarWithoutQuota";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "15rem",
    fontSize: "1rem",
    color: "black",
    textAlign: "center",
    background: "white",
    border: "0.5px solid lightgrey",
  },
});

class TimeSeriesPredictionv2 extends React.Component {
  chartRef = React.createRef();

  state = {
    closed_year: ["All"],
    closed_month: ["All"],
    quarter: ["All"],
    rep: ["All"],
    fiscal_quarter: ["All"],
    Cust_Type: ["All"],
    Region_Rollup: ["All"],
    Booking_Type_NL_CS_US: ["All"],
    Acct_Industry: ["All"],
    Lead_Source: ["All"],
    Lead_Source_Category__c:["All"],
    Department_Lead_Source: ["All"],
    Opp_Created_By: ["All"],
    Solution_Cat: ["All"],
    Product_Family: ["All"],
    custType: ["All"],
    deal_category__c: ["All"],
    Acct_Segment: ["All"],
    Acct_Size_Segment: ["All"],
    team: ["All"],
    timeFrame: "quarter",
    disabled: [],
    acvPreset: "All",
    acv: null,
    acvlt: 0,
    displayacv: 0,
    acvRadio: "preset",
    acvError: "",
    location: "overview",
    defaultColDef: {
      flex: 1,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      sortable: true,
      resizable: true,
    },
    selectedDrilldownStage: "",
    lastStage: false,
    activeFilters: ["All"],

    filtersForDrilldown: [],
    toggleValue: "AcvSort",
    secondLevelLocation: null,
    THRESHOLDS_VALUES: 0,
    exclude_large_deals: "Yes",
    lookback_quarter: 4,
    offset_days: 0,
    INCLUDE_ALL_CQ_WON: "Yes",
    cross_sell1__c: ["All"],
    Type: ["All"],
    Channel_Partner_Name__c: ["All"],
    tab: "Summary",
    exclude_acv_lte_zero: "Yes",
    Acct_Emp_Range: ["All"],
    Acct_Type: ["All"],
    Region__c: ["All"],
    Channel_Type__c: ["All"],
    Opportunity_Source_Channel__c: ["All"],
    Transaction_Type__c: ["All"],
    showEstimatedAdditionalPipeline: false,
    ACV_Range: ["All"],
    Region: ["All"],
  };

  // filters = ['closed_year', 'closed_month', 'quarter', 'rep', 'fiscal_quarter', 'team', 'Cust_Type', 'Acct_Industry', 'custType', "Booking_Type_NL_CS_US", 'Acct_Size_Segment','Acct_Segment', 'Lead_Source', 'Opp_Created_By', 'Solution_Cat', 'Region_Rollup','deal_category__c']

  filters = [
    "fiscal_quarter",
    "lookback_quarter",
    "offset_days",
    "INCLUDE_ALL_CQ_WON",
    "Solution_Cat",
    "Product_Family",
    "team",
    "deal_category__c",
    "Type",
    "Channel_Partner_Name__c",
    "cross_sell1__c",
    "Cust_Type",
    "exclude_acv_lte_zero",
    "Acct_Emp_Range",
    "Acct_Type",
    "Opportunity_Source_Channel__c",
    "Region__c",
    "Channel_Type__c",
    "Transaction_Type__c",
    "Acct_Industry",
    "Acct_Size_Segment",
    "Acct_Segment",
    "Lead_Source",
    "Lead_Source_Category__c",
    "Department_Lead_Source",
    "Opp_Created_By",
    "ACV_Range",
    "Region"
  ];

  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: Smooth scrolling animation
    });
    this.props.getFunnelFilters(this.props.company);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
    this.props.clearVariables()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.funnelFilters !== "" && prevProps.funnelFilters === "") {
      const defaultFQuarter = getDefaultSelectedFiscalQuarters(
        this.props.funnelFilters.fiscalQuarters,
        "fiscal_quarter"
      );
      var defaultQuarter =
        defaultFQuarter.length > 0 ? defaultFQuarter : ["All"];
      const defaultOffsetDays = this.props.funnelFilters.defaultOffsetDays;
      let days = 0;
      if (defaultOffsetDays) {
        days = defaultOffsetDays;
      }

      let excludDeals = "Yes";
      if (this.props.funnelFilters.exclude_large_deals) {
        excludDeals =
          getDefaultSalesType(
            this.props.funnelFilters.exclude_large_deals,
            "exclude_large_deals"
          )[0] === "All"
            ? "No"
            : getDefaultSalesType(
                this.props.funnelFilters.exclude_large_deals,
                "exclude_large_deals"
              )[0];
        // this.setState({
        //   ...prevState,
        //   [oppTypeColumn]:oppTypes,
        //   oppType : oppTypeColumn,
        // })
      }

      let incluAllCq = "Yes";
      if (this.props.funnelFilters.includeCQWon) {
        incluAllCq =
          getDefaultSalesType(
            this.props.funnelFilters.includeCQWon,
            "INCLUDE_ALL_CQ_WON"
          )[0] === "All"
            ? "No"
            : getDefaultSalesType(
                this.props.funnelFilters.includeCQWon,
                "INCLUDE_ALL_CQ_WON"
              )[0];
      }

      let excludeACVLTEZ = "Yes";
      if (this.props.funnelFilters.exclude_acv_lte_zero) {
        excludeACVLTEZ =
          getDefaultSalesType(
            this.props.funnelFilters.exclude_acv_lte_zero,
            "exclude_acv_lte_zero"
          )[0] === "All"
            ? "No"
            : getDefaultSalesType(
                this.props.funnelFilters.exclude_acv_lte_zero,
                "exclude_acv_lte_zero"
              )[0];
        // this.setState({
        //   ...prevState,
        //   [oppTypeColumn]:oppTypes,
        //   oppType : oppTypeColumn,
        // })
      }

      const noOfDays = this.props.funnelFilters.numberOfDaysInQuarter.filter(
        (f) => defaultFQuarter.includes(f.quarter)
      )[0].noOfDays;
      let thresholdValues = 0;
      if (excludDeals === "Yes") {
        thresholdValues =
          getDefaultThreshold(this.props.funnelFilters.large_deal_threshold) > 0
            ? d3.format(",")(
                String(
                  getDefaultThreshold(
                    this.props.funnelFilters.large_deal_threshold
                  )
                )
              )
            : getDefaultThreshold(
                this.props.funnelFilters.large_deal_threshold
              );
      }
      //Set team filter default value
      let defaultvalueTeam;
      if (this.props.funnelFilters !== "") {
        const val = this.props.funnelFilters.parentChildrenTeamFilter;
        defaultvalueTeam = val.defaultValueTeam;
      }

       let productFamily = ["All"];
        productFamily = getDefaultSalesType(
              this.props.funnelFilters.Product_Family,
              "Product_Family"
            );
            let af = []
      if (productFamily[0] !== "All") {
        af = [
          ...af,
          { name: "Product_Family", value: productFamily },
        ];
      }

      
      this.setState({
        ...prevState,
        team: defaultvalueTeam ? defaultvalueTeam : ["All"],
        fiscal_quarter: defaultQuarter,
        filtersForDrilldown: [
          {
            title: "Fiscal Qtr.",
            value: defaultQuarter,
          },
          ...this.state.filtersForDrilldown.filter(
            (f) => f.title !== "Closed Fiscal Qtr."
          ),
        ],
        activeFilters: [
          { name: "closed_fiscal_quarter", value: defaultQuarter, ...af },
        ],
        exclude_large_deals: excludDeals,
        THRESHOLDS_VALUES: thresholdValues,
        offset_days: days,
        noOfDaysInQUarter: noOfDays,
        INCLUDE_ALL_CQ_WON: incluAllCq,
        exclude_acv_lte_zero: excludeACVLTEZ,
        Product_Family: productFamily,
      });      
    }
  }

  handleChange = (e) => {
    let noOfDays = this.state.noOfDaysInQUarter;
    let offsetDays = this.state.offset_days;
    if (e.target.name === "fiscal_quarter") {
      const quarters =
        [e.target.value].filter((f) => f !== "All").length > 0
          ? [e.target.value].filter((f) => f !== "All")
          : [];
      noOfDays =
        quarters.length > 0
          ? this.props.funnelFilters.numberOfDaysInQuarter.filter((f) =>
              quarters.includes(f.quarter)
            )[0].noOfDays
          : this.state.fiscal_quarter;
      offsetDays = 0;
    }

    if (
      e.target.name === "closed_year" &&
      e.target.value.filter((v) => v === "All").length > 0
    ) {
      this.setState({
        ...this.state,
        noOfDaysInQUarter: noOfDays,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        closed_month: ["All"],
        quarter: ["All"],
      });
    } else {
      this.setState({
        ...this.state,
        noOfDaysInQUarter: noOfDays,
        offset_days: offsetDays,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : [e.target.value],
      });
    }
  };

  handleChangeNew = (filteredValues) => {
    const nonAllValues = filteredValues.filter((v) => v !== "All");

    let newTeam;
    if (filteredValues.includes("All")) {
      newTeam = ["All"];
    } else if (nonAllValues.length === 0) {
      // Prevent deselecting the last item - keep current selection
      newTeam = this.state.team;
    } else {
      newTeam = nonAllValues;
    }

    this.setState({ team: newTeam });
  };

  handleChangeTab = (e) => {
    this.setState({ tab: "Ensemble" }, () => {
      // Call handleGo after setting the state
      this.handleGo();
    });
    console.log(e.target.value);
    const defaultFQuarter = getDefaultSelectedFiscalQuarters(
      this.props.funnelFilters.fiscalQuarters,
      "fiscal_quarter"
    );
    var defaultQuarter = defaultFQuarter.length > 0 ? defaultFQuarter : ["All"];
    const defaultOffsetDays = this.props.funnelFilters.defaultOffsetDays;
    let days = 0;
    if (defaultOffsetDays) {
      days = defaultOffsetDays;
    }

    let incluAllCq = "Yes";
    if (this.props.funnelFilters.includeCQWon) {
      incluAllCq =
        getDefaultSalesType(
          this.props.funnelFilters.includeCQWon,
          "INCLUDE_ALL_CQ_WON"
        )[0] === "All"
          ? "No"
          : getDefaultSalesType(
              this.props.funnelFilters.includeCQWon,
              "INCLUDE_ALL_CQ_WON"
            )[0];
      // this.setState({
      //   ...prevState,
      //   [oppTypeColumn]:oppTypes,
      //   oppType : oppTypeColumn,
      // })
    }

    const noOfDays = this.props.funnelFilters.numberOfDaysInQuarter.filter(
      (f) => defaultFQuarter.includes(f.quarter)
    )[0].noOfDays;

    if (e.target.value === "Ensemble") {
      this.setState({
        ...this.state,
        tab: e.target.value,
        fiscal_quarter: defaultFQuarter,
        offset_days: days,
        noOfDaysInQUarter: noOfDays,
        INCLUDE_ALL_CQ_WON: "Yes",
      });
    } else {
      this.setState({
        ...this.state,
        tab: e.target.value,
      });
    }
  };

  handleChangeFilter = (e) => {
    // console.log(e)
    this.setState({
      ...this.state,
      [e.target.name]:
        e.target.name === "rep"
          ? [e.target.value]
          : e.target.value.length === 0
          ? ["All"]
          : this.state[e.target.name].length === 1 &&
            this.state[e.target.name].includes("All")
          ? e.target.value.filter((v) => v !== "All").length > 0
            ? e.target.value.filter((v) => v !== "All")
            : ["All"]
          : e.target.value.includes("All")
          ? ["All"]
          : e.target.value,
    });
  };

  handleChangeOffsetDays = (e) => {
    this.setState({
      ...this.state,
      offset_days: e.target.value,
    });
  };

  handleIncludeCQWon = (e) => {
    this.setState({
      ...this.state,
      INCLUDE_ALL_CQ_WON: e.target.value,
    });
  };

  handleExcludeACV = (e) => {
    this.setState({
      ...this.state,
      exclude_acv_lte_zero: e.target.value,
    });
  };

  handleChangeLookbackQtr = (e) => {
    this.setState({
      ...this.state,
      lookback_quarter: e.target.value,
    });
  };

  parseFormattedNumber = (value) => {
    if (value == null) return value;
    if (typeof value !== "string") return value;
    const parsed = parseInt(value.replace(/,/g, ""), 10);
    return Number.isNaN(parsed) ? value : parsed;
  };

  getFilterValue = (filterName) => {
    const value = this.state[filterName];
    if (!Array.isArray(value)) return value;
    if (value.includes("All")) return value;

    if (filterName === "rep") {
      return value.map((s) =>
        this.props.funnelFilters.reps.find((r) => r.Full_Name === s)?.UserID
      );
    }
    return value;
  };

  handleGo = () => {
    localStorage.removeItem("skygeni-auto-update");

    let filters = this.filters
      .map((f) => ({ name: f, value: this.getFilterValue(f) }))
      .filter((f) => {
        const isAll = Array.isArray(f.value) ? f.value.includes("All") : f.value === "All";
        return !isAll && !this.state.disabled.includes(f.name);
      });

    if (this.state.offset_days === 0) {
      filters = filters.filter((f) => f.name !== "offset_days");
    }

    if (this.state.exclude_large_deals === "Yes") {
      filters.push({
        name: "threshold",
        value: this.parseFormattedNumber(this.state.THRESHOLDS_VALUES),
        string: false,
      });
    }

    if (this.state.acv !== null) {
      filters.push({
        name: "acv",
        value: this.parseFormattedNumber(this.state.acv),
        string: false,
      });
    }

    if (this.state.acvlt !== null && this.state.acvlt !== 0) {
      filters.push({
        name: "acvlt",
        value: this.parseFormattedNumber(this.state.acvlt),
        string: false,
      });
    }

    if (this.state.tab === "Ensemble") {
      filters = filters.filter(
        (f) => !["fiscal_quarter", "offset_days", "INCLUDE_ALL_CQ_WON"].includes(f.name)
      );
      filters.push(
        {
          name: "fiscal_quarter",
          value: this.props.funnelFilters.fiscalQuarters
            .filter((f) => f.selected_by_default === "Y")
            .map((f) => f.fiscal_quarter),
        },
        { name: "INCLUDE_ALL_CQ_WON", value: "Yes" }
      );
      if (this.props.funnelFilters.defaultOffsetDays > 0) {
        filters.push({
          name: "offset_days",
          value: this.props.funnelFilters.defaultOffsetDays,
        });
      }
      console.log(filters, "qwerty");
    }

    this.props.getFunnelDataNew(filters);

    const pipelineFilterNames = [
      "Solution_Cat", "team", "deal_category__c", "Type",
      "cross_sell1__c", "Cust_Type", "Transaction_Type__c",
    ];
    const pipelineFilters = filters.filter((f) => pipelineFilterNames.includes(f.name));
    this.props.getPipelineCoverageData(pipelineFilters);

    this.setState({
      activeFilters: filters,
      filtersForDrilldown: this.passFiltersForDrilldown(),
      showEstimatedAdditionalPipeline: false,
    });
  };

  orderRepsByLastName = () => {
    let reps = this.props.funnelFilters.reps
      .map((r) => r.Full_Name)
      .map((rep) => {
        const res = rep.split(" ", 2);
        return {
          firstName: res[0],
          lastName: res[1],
          fullName: rep,
          sortName: `${res[1]} ${res[0]}`,
        };
      });
    function compare(a, b) {
      if (a.sortName < b.sortName) {
        return -1;
      }
      if (a.sortName > b.sortName) {
        return 1;
      }
      return 0;
    }
    reps.sort(compare);
    reps = [
      { firstName: "All", lastName: "All", fullName: "All", sortName: "All" },
      ...reps,
    ];
    const menuItems = reps.map((rep, index) => {
      return rep.fullName;
    });
    return menuItems;
  };

  handleChangeTimeFrame = (e) => {
    this.setState({
      ...this.state,
      timeFrame: e.target.value,
      disabled:
        e.target.value === "custom"
          ? [
              ...this.state.disabled.filter(
                (f) =>
                  f !== "closed_year" && f !== "closed_month" && f !== "quarter"
              ),
              "closed_fiscal_quarter",
            ]
          : [
              ...this.state.disabled.filter(
                (f) => f !== "closed_fiscal_quarter"
              ),
              "closed_year",
              "closed_month",
              "quarter",
            ],
    });
  };

  handleChangeLocation = (location, obj, key, tableHeader) => {
    if (location !== "overview") {
      var stage = obj.row;
      console.log(obj, "STAGE");
      var quarter = obj.cell;
      var drilldownFilters = [
        { title: "Fiscal Qtr.", value: quarter },
        { title: "Stage", value: stage },
      ];

      var filters = this.props.currentFilters.filter(
        (s) => s.name !== "fiscal_quarter"
      );
      filters = [
        ...filters,
        { name: "fiscal_quarter", value: quarter },
        { name: "Stage_At_Time_T", value: stage },
      ];
      var keyNames = ["Closed Fiscal Qtr.", "Fiscal Qtr.","Stage"];
      var filtersForDrilldown = this.state.filtersForDrilldown.filter(
        (i) => !keyNames.includes(i.title)
      );

      if (this.state.exclude_large_deals === "Yes") {
        filters = [
          ...filters,
          {
            name: "threshold",
            value: this.parseFormattedNumber(this.state.THRESHOLDS_VALUES),
            string: false,
          },
        ];
      }

      this.setState({
        ...this.state,
        location: location,
        secondLevelLocation: location,
        header: tableHeader,
        drildownACVName: key,
        filtersForDrilldown: [...filtersForDrilldown, ...drilldownFilters],
      });
      this.props.getConversionEffecienceyDrilldown(filters, key);
    } else {
      this.props.clearDrilldownData();
    }
  };

  passFiltersForDrilldown = () => {
    let filtersArray = [];
    if (!this.state.fiscal_quarter.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Fiscal Qtr.", value: this.state.fiscal_quarter.sort() },
      ];
    }
    if (!this.state.closed_year.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Closed Calendar Year", value: this.state.closed_year.sort() },
      ];
    }

    if (!this.state.Acct_Emp_Range.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Emp. Range",
          value: this.state.Acct_Emp_Range.sort(),
        },
      ];
    }
    if (!this.state.Acct_Type.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Type",
          value: this.state.Acct_Type.sort(),
        },
      ];
    }

    if (!this.state.Channel_Type__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === 'C0023' ? "Deal Type":"Channel Type",
          value: this.state.Channel_Type__c.sort(),
        },
      ];
    }

    if (!this.state.Transaction_Type__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Transaction Type",
          value: this.state.Transaction_Type__c.sort(),
        },
      ];
    }
    if (!this.state.Opportunity_Source_Channel__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Opp Source Channel",
          value: this.state.Opportunity_Source_Channel__c.sort(),
        },
      ];
    }
    if (!this.state.Region__c.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Region",
          value: this.state.Region__c.sort(),
        },
      ];
    }
    if (!this.state.Region.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Account Region",
          value: this.state.Region.sort(),
        },
      ];
    }

    if (!this.state.Type.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: ["C0017","C0024"].includes(this.props.company) ? "Opp. Type" : "Deal Type",
          value: this.state.Type,
        },
      ];
    }

    if (!this.state.closed_month.includes("All")) {
      filtersArray = [
        ...filtersArray,
        {
          title: "Closed Calendar Month",
          value: this.state.closed_month
            .sort((a, b) => (a < b ? -1 : 1))
            .map((i) => this.months[i - 1]),
        },
      ];
    }
    if (!this.state.rep.includes("All"))
      filtersArray = [...filtersArray, { title: "Rep", value: this.state.rep }];

    if (!this.state.team.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Team", value: this.state.team },
      ];

    if (!this.state.Booking_Type_NL_CS_US.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opportunity Type", value: this.state.Booking_Type_NL_CS_US },
      ];

    // if (this.state.acv !== null && this.state.acv !== 0)
    //   filtersArray = [...filtersArray, {
    //     title: "ACV Greater Than", value: '$ ' + d3.format(",")(this.state.acv && typeof (this.state.acv) === 'string' ?

    //       this.state.acv.match(/,/g) ?
    //         this.state.acv.match(/,/g).length === 1 ?
    //           parseInt(this.state.acv) * 1000
    //           :
    //           this.state.acv.match(/,/g).length === 2 ?
    //             parseInt(this.state.acv) * 1000000
    //             :
    //             parseInt(this.state.acv)
    //         :
    //         parseInt(this.state.acv)

    //       : this.state.acv)
    //   }]

    if (!this.state.Acct_Industry.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0003" ? "Vertical" : "Industry",
          value: this.state.Acct_Industry,
        },
      ];
    if (!this.state.Acct_Size_Segment.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: "Customer Segment",
          value:
            this.props.company === "C0003"
              ? this.state.Acct_Industry
              : this.state.Acct_Size_Segment,
        },
      ];
    if (!this.state.Cust_Type.includes("All"))
      filtersArray = [
        ...filtersArray,
        {
          title: this.props.company === "C0003" ? "Region" : "Customer Type",
          value:
            this.props.company === "C0003"
              ? this.state.Region_Rollup
              : this.state.Cust_Type,
        },
      ];
    if (!this.state.Department_Lead_Source.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Dept. Lead Source", value: this.state.Department_Lead_Source },
      ];

    if (!this.state.Lead_Source.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Lead Source", value: this.state.Lead_Source },
      ];

    if (!this.state.Lead_Source_Category__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Lead Source Category", value: this.state.Lead_Source_Category__c },
      ];

    if (!this.state.Channel_Partner_Name__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Channel Partner Name", value: this.state.Channel_Partner_Name__c },
      ];

    if (!this.state.Opp_Created_By.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Opportunity Created By", value: this.state.Opp_Created_By },
      ];

    if (!this.state.deal_category__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Deal Category", value: this.state.deal_category__c },
      ];

     if (!this.state.cross_sell1__c.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Sales Type", value: this.state.cross_sell1__c },
      ];

    if (!this.state.Product_Family.includes("All"))
      filtersArray = [
        ...filtersArray,
        { title: "Product Family Contains", value: this.state.Product_Family },
      ];

    if (
      this.props.company !== "C0003" &&
      !this.state.Solution_Cat.includes("All")
    )
      filtersArray = [
        ...filtersArray,
        { title: "Solution Category", value: this.state.Solution_Cat },
      ];

    return filtersArray;
  };

  onRepChange = (event, value) => {
    this.setState({
      ...this.state,
      rep: [value ? value : "All"],
    });
  };

  onAcvChange = (event, value) => {
    this.setState({
      ...this.state,
      acv: value,
    });
  };

  onAcvLtChange = (event, value) => {
    this.setState({
      ...this.state,
      acvlt: value,
    });
  };

  onThresholdChange = (event, value) => {
    console.log(
      this.state.exclude_large_deals,
      this.state.THRESHOLDS_VALUES,
      value
    );
    this.setState({
      ...this.state,
      THRESHOLDS_VALUES: [null, ""].includes(value)
        ? d3.format(",")(
            String(
              getDefaultThreshold(this.props.funnelFilters.large_deal_threshold)
            )
          )
        : value,
    });
  };

  handleChangeLocationBack = (location) => {
    this.setState({
      ...this.state,
      location: "",
      secondLevelLocation: "",
    });
  };

  handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    this.setState({
      ...this.state,
      secondLevelLocation: location,
    });
    this.props.getOpenOppData(oppId);
  };

  stepBack = () => {
    this.setState({
      ...this.state,
      secondLevelLocation: "",
    });
    this.props.clearExpectedAcvData();
  };

  handleToggleEstimate = () => {
    this.setState((prevState) => ({
      showEstimatedAdditionalPipeline: !prevState.showEstimatedAdditionalPipeline,
    }));
  };

  render() {
    const { classes } = this.props;

    let teamObject;
    if (this.props.funnelFilters !== "") {
      teamObject = this.props.funnelFilters.parentChildrenTeamFilter;
    }

    return (
      <Grid container style={{ position: "relative" }}>
        {/* Caption and description */}

        {/* {addHeaderdescription(
          "Time Series projection of Closed Won",
          "Project and back test Closed Won based on a time series model and historical macro factors."
        )} */}
        <AddHeaderDescriptionWithHelperText
          header={`Time Series projection of Closed Won`}
          description={`Project and back test Closed Won based on a time series model and historical macro factors.`}
          helperTextCharts={this.props.helperTextCharts}
        />

        {this.props.funnelFilters ? (
          <>
            {/* dates */}
            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={2}
              md={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={2} sm={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-fiscalQuarter-label"
                      style={{
                        color: !this.state.fiscal_quarter.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Fiscal Qtr.:
                    </InputLabel>
                    <Select
                      data-test="closed-fiscal-quarter"
                      labelId="select-fiscalQuarter-label"
                      id="select-fiscalQuarter"
                      value={this.state.fiscal_quarter}
                      onChange={this.handleChange}
                      label="Closed Fiscal Qtr."
                      name="fiscal_quarter"
                    >
                      {/* <MenuItem value={'All'}>All</MenuItem> */}
                      {this.props.funnelFilters !== "" &&
                        Array.isArray(this.props.funnelFilters.fiscalQuarters) &&
                        (this.state.tab === "Ensemble"
                          ? this.props.funnelFilters.fiscalQuarters
                              .filter(
                                (item) =>
                                  item.fiscal_quarter !== "" &&
                                  item.selected_by_default === "Y"
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y.fiscal_quarter}
                                  value={y.fiscal_quarter}
                                >
                                  {y.fiscal_quarter}
                                </MenuItem>
                              ))
                          : this.props.funnelFilters.fiscalQuarters
                              .filter((item) => item.fiscal_quarter !== "")
                              .map((y) => (
                                <MenuItem
                                  key={y.fiscal_quarter}
                                  value={y.fiscal_quarter}
                                >
                                  {y.fiscal_quarter}
                                </MenuItem>
                              )))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={2}
              md={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={2} sm={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-offset_days-label"
                      style={{ color: "#4472c4" }}
                    >
                      Day in Qtr.:
                    </InputLabel>
                    {this.state.tab === "Ensemble" ? (
                      <Select
                        data-test="offset_days"
                        labelId="soffset_days-label"
                        id="offset_days"
                        value={this.state.offset_days}
                        onChange={this.handleChangeOffsetDays}
                        label="Day in Qtr."
                        name="offset_days"
                      >
                        <MenuItem
                          value={this.props.funnelFilters.defaultOffsetDays}
                        >
                          {this.props.funnelFilters.defaultOffsetDays}
                        </MenuItem>
                      </Select>
                    ) : (
                      <Select
                        data-test="offset_days"
                        labelId="soffset_days-label"
                        id="offset_days"
                        value={this.state.offset_days}
                        onChange={this.handleChangeOffsetDays}
                        label="Day in Qtr."
                        name="offset_days"
                      >
                        <MenuItem value={0}>0</MenuItem>
                        {Array(this.state.noOfDaysInQUarter)
                          .fill(0)
                          .map((x, y) => (
                            <MenuItem key={y + 1} value={y + 1}>
                              {y + 1}
                            </MenuItem>
                          ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={2}
              md={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={12} sm={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-offset_days-label"
                      style={{ color: "#4472c4", width: 200 }}
                    >
                      Lookback Period:
                    </InputLabel>
                    <Select
                      data-test="lookback_period"
                      labelId="lookback_quarter_label"
                      id="lookback_quarter"
                      value={this.state.lookback_quarter}
                      onChange={this.handleChangeLookbackQtr}
                      label="lookback_quarter"
                      name="lookback_quarter"
                    >
                      {Array(6)
                        .fill(0)
                        .map((_, i) => (
                          <MenuItem key={i + 1} value={i + 1}>
                            {i + 1}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={2}
              md={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={2} sm={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-include_all_cq-label"
                      style={{ color: "#4472c4", whiteSpace: "nowrap" }}
                    >
                      Include all CQ Won:
                    </InputLabel>
                    <Select
                      data-test="INCLUDE_ALL_CQ_WON"
                      labelId="INCLUDE_ALL_CQ_WON-label"
                      id="INCLUDE_ALL_CQ_WON"
                      value={this.state.INCLUDE_ALL_CQ_WON}
                      onChange={this.handleIncludeCQWon}
                      label="Include all CQ Won:"
                      name="INCLUDE_ALL_CQ_WON"
                    >
                      {this.props.funnelFilters !== "" &&
                        (this.state.tab === "Ensemble"
                          ? this.props.funnelFilters.includeCQWon
                              .filter(
                                (item) =>
                                  item.INCLUDE_ALL_CQ_WON !== "" &&
                                  item.INCLUDE_ALL_CQ_WON === "Yes"
                              )
                              .map((y) => (
                                <MenuItem
                                  key={y.INCLUDE_ALL_CQ_WON}
                                  value={y.INCLUDE_ALL_CQ_WON}
                                >
                                  {y.INCLUDE_ALL_CQ_WON}
                                </MenuItem>
                              ))
                          : this.props.funnelFilters.includeCQWon
                              .filter((item) => item.INCLUDE_ALL_CQ_WON !== "")
                              .map((y) => (
                                <MenuItem
                                  key={y.INCLUDE_ALL_CQ_WON}
                                  value={y.INCLUDE_ALL_CQ_WON}
                                >
                                  {y.INCLUDE_ALL_CQ_WON}
                                </MenuItem>
                              )))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={3}
              md={3}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                justify="space-around"
              >
                <Grid item xs={6} style={{ paddingBottom: "4px" }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      className={classes.filterLabel}
                      style={{
                        color: !this.state.exclude_large_deals.includes("All")
                          ? "#4472c4"
                          : "#000",
                        whiteSpace: "nowrap",
                      }}
                      id="select-exclude-label"
                    >
                      Exclude large deals:
                    </InputLabel>
                    <Select
                      value={this.state.exclude_large_deals}
                      onChange={this.handleChangeFilter}
                      name="exclude_large_deals"
                      data-test="exclude_large_deals"
                    >
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.exclude_large_deals.map(
                          (y) => (
                            <MenuItem
                              key={y["exclude_large_deals"]}
                              value={y["exclude_large_deals"]}
                            >
                              {y["exclude_large_deals"]}
                            </MenuItem>
                          )
                        )}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6} style={{ paddingBottom: "4px" }}>
                  {console.log(
                    this.state.exclude_large_deals,
                    this.state.THRESHOLDS_VALUES,
                    "ThresholdsValues"
                  )}
                  {this.state.exclude_large_deals === "Yes" ? (
                    <Autocomplete
                      id="free-solo-demo"
                      freeSolo
                      options={
                        this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.large_deal_threshold.map((d) =>
                          d3.format(",")(String(d.THRESHOLDS_VALUES))
                        )
                      }
                      // options={this.props.company === 'C0001' ? ['0', '5,000', '10,000', '15,000', '20,000', '30,000', '50,000', '100,000'] : ['0', '50,000', '100,000', '250,000', '500,000', '750,000', '1,000,000']}
                      //getOptionLabel={(option) => typeof (option) === 'string' ? option : stringNumFormatter(parseInt(option))}
                      onChange={this.onThresholdChange}
                      value={d3.format(",")(
                        String(
                          getDefaultThreshold(
                            this.props.funnelFilters.large_deal_threshold
                          )
                        )
                      )}
                      // value={this.state.acv}
                      data-test="THRESHOLDS_VALUES"
                      autoSelect={true}
                      disabled={this.state.exclude_large_deals !== "Yes"}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Threshold > :"
                          margin="normal"
                          variant="standard"
                          style={{ marginTop: 4 }}
                          InputLabelProps={{
                            shrink: true,
                            style: {
                              color:
                                this.state.THRESHOLDS_VALUES !== null &&
                                this.state.THRESHOLDS_VALUES !== 0 &&
                                this.state.exclude_large_deals === "Yes"
                                  ? "#4472c4"
                                  : "#000",
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            inputComponent: NumberFormatCustom,
                            startAdornment: (
                              <>
                                <InputAdornment position="start">
                                  {/* $ */}
                                  {this.props.Currency_Symbol}
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  ) : (
                    <Autocomplete
                      id="free-solo-demo"
                      freeSolo
                      options={[]}
                      // options={this.props.company === 'C0001' ? ['0', '5,000', '10,000', '15,000', '20,000', '30,000', '50,000', '100,000'] : ['0', '50,000', '100,000', '250,000', '500,000', '750,000', '1,000,000']}
                      //getOptionLabel={(option) => typeof (option) === 'string' ? option : stringNumFormatter(parseInt(option))}
                      onChange={this.onThresholdChange}
                      value={
                        this.state.exclude_large_deals !== "Yes"
                          ? ""
                          : this.state.THRESHOLDS_VALUES
                      }
                      // value={this.state.acv}
                      data-test="THRESHOLDS_VALUES"
                      autoSelect={true}
                      disabled={this.state.exclude_large_deals !== "Yes"}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Threshold > :"
                          margin="normal"
                          variant="standard"
                          style={{ marginTop: 4 }}
                          InputLabelProps={{
                            shrink: true,
                            style: {
                              color:
                                this.state.THRESHOLDS_VALUES !== null &&
                                this.state.THRESHOLDS_VALUES !== 0 &&
                                this.state.exclude_large_deals === "Yes"
                                  ? "#4472c4"
                                  : "#000",
                            },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            inputComponent: NumberFormatCustom,
                            startAdornment: (
                              <>
                                <InputAdornment position="start">
                                  {/* $ */}
                                  {this.props.Currency_Symbol}
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>

            {/* ACV and GO */}
            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              justify="space-between"
              xs={1}
              lg={1}
            >
              <Grid item xs={6} xl={6} container justify="flex-end">
                <Button
                  data-test="go"
                  variant="contained"
                  color="primary"
                  onClick={this.handleGo}
                >
                  GO
                </Button>
              </Grid>
            </Grid>

            {/* First Group */}
                        {!["C0003"].includes(this.props.company) && (
                          <Grid container item style={{ padding: 10, paddingTop: 15 }} xs={ this.props.company === "C0003" ? 4 : 6}>
                          <Grid
                            item
                            spacing={2}
                            xs={12}
                            container
                            component={Paper}
                            style={{ paddingTop: 8 }}
                          >
                            <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                              <FormControl fullWidth className={classes.formControl}>
                                <InputLabel
                                  className={classes.filterLabel}
                                  style={{
                                    color: !this.state.Acct_Industry.includes("All")
                                      ? "#4472c4"
                                      : "#000",
                                  }}
                                  id="select-industry-label"
                                >
                                  {this.props.company === "C0003" ? "Region:" : "Industry:"}
                                </InputLabel>
                                <Select
                                  data-test="Industry"
                                  value={this.state.Acct_Industry}
                                  onChange={this.handleChangeFilter}
                                  name={"Acct_Industry"}
                                  multiple
                                >
                                  <MenuItem value={"All"}>All</MenuItem>
                                  {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.industriesType
                                      .map((t) => t.Acct_Industry)
                                      .sort()
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                              {this.props.company === "C0003" ? (
                                 <FormControl fullWidth className={classes.formControl}>
                                  <InputLabel
                                    className={classes.filterLabel}
                                    style={{
                                      color: !this.state.Acct_Segment.includes("All")
                                        ? "#4472c4"
                                        : "#000",
                                    }}
                                    id="select-region-label"
                                  >
                                    Customer Segment:
                                  </InputLabel>
                                  <Select
                                    data-test="Acct_Segment"
                                    value={this.state.Acct_Segment}
                                    onChange={this.handleChangeFilter}
                                    name="Acct_Segment"
                                    multiple
                                  >
                                    <MenuItem value={"All"}>All</MenuItem>
                                    {this.props.funnelFilters !== "" &&
                                      this.props.funnelFilters.Segment.map((y) => (
                                        <MenuItem
                                          key={y}
                                          value={y}
                                        >
                                          {y}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>               
                              ) : (
                              <FormControl fullWidth className={classes.formControl}>
                                <InputLabel
                                  className={classes.filterLabel}
                                  style={{
                                    color: !this.state.Acct_Size_Segment.includes("All")
                                      ? "#4472c4"
                                      : "#000",
                                  }}
                                  id="select-region-label"
                                >
                                  Customer Segment:
                                </InputLabel>
                                <Select
                                  data-test="Customer Segment"
                                  value={this.state.Acct_Size_Segment}
                                  onChange={this.handleChangeFilter}
                                  name={"Acct_Size_Segment"}
                                  multiple
                                >
                                  <MenuItem value={"All"}>All</MenuItem>
                                 {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.custSegType
                                      .map((t) => t.Acct_Size_Segment)
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                </Select>
                              </FormControl>
                                )}
                            </Grid>
                            
                            <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                                <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-Cust_Type-label"
                      style={{
                        color: !this.state.Cust_Type.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Customer Type:
                    </InputLabel>
                    <Select
                      labelId="select-Cust_Type-label"
                      id="select-Cust_Type"
                      value={this.state.Cust_Type}
                      onChange={this.handleChangeFilter}
                      name="Cust_Type"
                      data-test="Cust_Type"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.cust_type
                          .map((f) => f.Cust_Type)
                          .sort()
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                                </FormControl>
                            </Grid>
                           
                          </Grid>
                        </Grid>
                        )}

            {/* Second Group */}
                        {!["C0003"].includes(this.props.company) && (
                        <Grid container item style={{ padding: 10, paddingTop: 15 }} xs={["C0003"].includes(this.props.company) ? 4 : 6}>
                          <Grid
                            item
                            spacing={2}
                            xs={12}
                            container
                            component={Paper}
                            style={{ paddingTop: 8 }}
                          >
                            <Grid item xs={12} sm={["C0003"].includes(this.props.company) ? 6 : 4} style={{ paddingTop: 0 }}>
                              {this.props.company === "C0024" ? (
                                <FormControl fullWidth className={classes.formControl}>
                                  <InputLabel
                                    className={classes.filterLabel}
                                    style={{
                                      color: !this.state.Lead_Source.includes("All")
                                        ? "#4472c4"
                                        : "#000",
                                    }}
                                    id="select-region-label"
                                  >
                                    Lead Source Category:
                                  </InputLabel>
                                  <Select
                                    data-test="Lead_Source_Category__c"
                                    value={this.state.Lead_Source_Category__c}
                                    onChange={this.handleChangeFilter}
                                    name={"Lead_Source_Category__c"}
                                    multiple
                                  >
                                    <MenuItem value={"All"}>All</MenuItem>
                                    {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.Lead_Source_Category
                                      .map((t) => t.Lead_Source_Category__c)
                                      .sort()
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              ) : (
                              <FormControl fullWidth className={classes.formControl}>
                                  <InputLabel
                                    className={classes.filterLabel}
                                    style={{
                                      color: !this.state.Lead_Source.includes("All")
                                        ? "#4472c4"
                                        : "#000",
                                    }}
                                    id="select-region-label"
                                  >
                                    Lead Source:
                                  </InputLabel>
                                  <Select
                                    data-test="Lead_Source"
                                    value={this.state.Lead_Source}
                                    onChange={this.handleChangeFilter}
                                    name={"Lead_Source"}
                                    multiple
                                  >
                                    <MenuItem value={"All"}>All</MenuItem>
                                    {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.leadSourceType
                                      .map((t) => t.Lead_Source)
                                      .sort()
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={["C0003"].includes(this.props.company) ? 6 : 4} style={{ paddingTop: 0 }}>
                              {["C0023"].includes(this.props.company) ? (
                                <FormControl fullWidth className={classes.formControl}>
                                  <InputLabel
                                    className={classes.filterLabel}
                                    style={{
                                      color: !this.state.Department_Lead_Source.includes("All")
                                        ? "#4472c4"
                                        : "#000",
                                    }}
                                    id="select-department-lead-source-label"
                                  >
                                    Dept. Lead Source:
                                  </InputLabel>
                                  <Select
                                    data-test="Department_Lead_Source"
                                    value={this.state.Department_Lead_Source}
                                    onChange={this.handleChangeFilter}
                                    name="Department_Lead_Source"
                                    multiple
                                  >
                                    <MenuItem value={"All"}>All</MenuItem>
                                    {this.props.funnelFilters !== "" &&
                                      this.props.funnelFilters.Department_Lead_Source &&
                                      this.props.funnelFilters.Department_Lead_Source
                                        .map((t) => t.Department_Lead_Source)
                                        .sort()
                                        .map((y) => (
                                          <MenuItem key={y} value={y}>
                                            {y}
                                          </MenuItem>
                                        ))}
                                  </Select>
                                </FormControl>
                              ) : (
                              <FormControl fullWidth className={classes.formControl}>
                                <InputLabel
                                  className={classes.filterLabel}
                                  style={{
                                    color: !this.state.Opp_Created_By.includes("All")
                                      ? "#4472c4"
                                      : "#000",
                                  }}
                                  id="select-opp_created_by"
                                >
                                  {'Opportunity Created By:'}
                                </InputLabel>
                                <Select
                                  value={this.state.Opp_Created_By}
                                  onChange={this.handleChangeFilter}
                                  name={"Opp_Created_By"}
                                  data-test={"Opp_Created_By"}
                                  multiple
                                >
                                  <MenuItem value={"All"}>All</MenuItem>
                                  {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.oppCreatedByType
                                      .map((t) => t.Opp_Created_By)
                                      .sort()
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                </Select>
                              </FormControl>
                              )}
                            </Grid>
                             {!["C0003"].includes(this.props.company) && (
                            <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                              {this.props.company === "C0024" ? (
                                 <FormControl fullWidth className={classes.formControl}>
                                <InputLabel
                                  className={classes.filterLabel}
                                  style={{
                                    color: !this.state.Product_Family.includes("All")
                                      ? "#4472c4"
                                      : "#000",
                                  }}
                                  id="select-region-label"
                                >
                                  Product Family Contains:
                                </InputLabel>
                                <Select
                                  data-test="Product Family"
                                  value={this.state.Product_Family}
                                  onChange={this.handleChangeFilter}
                                  name={"Product_Family"}
                                  multiple
                                >
                                  <MenuItem value={"All"}>All</MenuItem>
                                 {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.Product_Family
                                      .map((t) => t.Product_Family)
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                                </Select>
                              </FormControl>
                              ) : (
                              <FormControl fullWidth className={classes.formControl}>
                                  <InputLabel
                                    id="select-Acct_Industry-label"
                                    style={{
                                      color: !this.state.Solution_Cat.includes("All")
                                        ? "#4472c4"
                                        : "#000",
                                    }}
                                  >
                                    Solution Category:
                                  </InputLabel>
                                  <Select
                                    labelId="select-Acct_Industry-label"
                                    id="select-Acct_Industry"
                                    value={this.state.Solution_Cat}
                                    onChange={this.handleChangeFilter}
                                    name="Solution_Cat"
                                    data-test="solution_category"
                                    multiple
                                  >
                                    <MenuItem value={"All"}>All</MenuItem>
                                    {this.props.funnelFilters !== "" &&
                                      this.props.funnelFilters.solutionCat
                                        .sort()
                                        .filter((item) => item !== "")
                                        .map((y) => (
                                          <MenuItem key={y} value={y}>
                                            {y}
                                          </MenuItem>
                                        ))}
                                  </Select>
                              </FormControl>
                              )}
                            </Grid>
                             )}
                          </Grid>
                        </Grid>
                        )}

 {/* Adding Acv Value */}
           
            {/* Acv Range Filter */}
{/* {!["C0003"].includes(this.props.company) && (
                <Grid
                item
                container
                xs={2}
                className={classes.repTeamFilterContainer}
                component={Paper}
              >
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      className={classes.filterLabel}
                      style={{
                        color: !this.state.ACV_Range.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                      id="select-region-label"
                    >
                      {`${this.props.Value_Label} Range`}:
                    </InputLabel>
                    <Select
                      data-test="ACV_Range"
                      value={this.state.ACV_Range}
                      onChange={this.handleChangeFilter}
                      name="ACV_Range"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                                    this.props.funnelFilters.ACVRangeFilter
                                      .map((t) => t.ACV_Range)
                                      .sort()
                                      .map((y) => (
                                        <MenuItem key={y} value={y}>
                                          {y}
                                        </MenuItem>
                                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
)} */}

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={2}
              md={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={12} sm={12} style={{ paddingTop: 0 }}>
                  <TeamFilterHierarchy
                    label="Team:"
                    value={this.state.team}
                    data={teamObject.filters}
                    onTeamChange={this.handleChangeNew}
                    name="team"
                    disabled={!this.state.rep.includes("All")}
                    labelColorCondition={!this.state.team.includes("All")}
                    renderValue={(selected) => selected.join(", ")}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) =>
                      option.parentValue + option.label
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

           

            {/* C0017 */}
            {["C0017", "C0024"].includes(this.props.company) && (
              <Grid
                container
                item
                style={{ padding: 10, paddingTop: 15 }}
                xs={2}
                md={2}
              >
                <Grid
                  item
                  spacing={2}
                  xs={12}
                  container
                  component={Paper}
                  style={{ paddingTop: 8 }}
                >
                  <Grid item xs={12} sm={12} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        className={classes.filterLabel}
                        // style={{ color: "#4472c4" }}
                        style={{
                          color: !this.state.Type.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                        id="select-region-label"
                      >
                        Opp. Type:
                      </InputLabel>
                      <Select
                        data-test="OppType"
                        value={this.state.Type}
                        onChange={this.handleChangeFilter}
                        name="Type"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters.Type !== "" &&
                          this.props.funnelFilters.Type.filter(
                            (y) => y.type === "Type" && y.Type !== ""
                          ).map((y) => (
                            <MenuItem key={y.Type} value={y.Type}>
                              {y.Type}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}

             {["C0024"].includes(this.props.company) && (
              <Grid
                container
                item
                style={{ padding: 10, paddingTop: 15 }}
                xs={2}
                md={2}
              >
                <Grid
                  item
                  spacing={2}
                  xs={12}
                  container
                  component={Paper}
                  style={{ paddingTop: 8 }}
                >
                  <Grid item xs={12} sm={12} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        className={classes.filterLabel}
                        // style={{ color: "#4472c4" }}
                        style={{
                          color: !this.state.Channel_Partner_Name__c.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                        id="select-region-label"
                      >
                        Channel Partner Name:
                      </InputLabel>
                      <Select
                        data-test="ChannelPartnerName"
                        value={this.state.Channel_Partner_Name__c}
                        onChange={this.handleChangeFilter}
                        name="Channel_Partner_Name__c"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters.Channel_Partner_Name !== "" &&
                          this.props.funnelFilters.Channel_Partner_Name.filter(
                            (y) => y.type === "Channel_Partner_Name__c" && y.Channel_Partner_Name__c !== ""
                          ).map((y) => (
                            <MenuItem key={y.Channel_Partner_Name__c} value={y.Channel_Partner_Name__c}>
                              {y.Channel_Partner_Name__c}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {this.props.company === "C0001" && (
              <Grid
                container
                item
                style={{ padding: 10, paddingTop: 15 }}
                xs={2}
                md={2}
              >
                <Grid
                  item
                  spacing={2}
                  xs={12}
                  container
                  component={Paper}
                  style={{ paddingTop: 8 }}
                >
                  <Grid item xs={12} sm={12} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        id="select-Acct_Industry-label"
                        style={{
                          color: !this.state.deal_category__c.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                      >
                        Deal Category:
                      </InputLabel>
                      <Select
                        labelId="select-Acct_Industry-label"
                        id="select-Acct_Industry"
                        value={this.state.deal_category__c}
                        onChange={this.handleChangeFilter}
                        name="deal_category__c"
                        data-test="deal_category__c"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters !== "" &&
                          this.props.funnelFilters.dealCat
                            .sort()
                            .filter((item) => item !== "")
                            .map((item) => item.deal_category__c)
                            .map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {this.props.company === "C0008" && (
              <Grid
                container
                item
                style={{ padding: 10, paddingTop: 15 }}
                xs={4}
              >
                <Grid
                  item
                  spacing={2}
                  xs={12}
                  container
                  component={Paper}
                  style={{ paddingTop: 8 }}
                >
                  <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        className={classes.filterLabel}
                        style={{
                          color: !this.state.cross_sell1__c.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                        id="select-region-label"
                      >
                        Sales Type:
                      </InputLabel>
                      <Select
                        data-test="cross_sell1__c"
                        value={this.state.cross_sell1__c}
                        onChange={this.handleChangeFilter}
                        name="cross_sell1__c"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters !== "" &&
                          this.props.funnelFilters.salesType.map((y) => (
                            <MenuItem
                              key={y.cross_sell1__c}
                              value={y.cross_sell1__c}
                            >
                              {y.cross_sell1__c}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        className={classes.filterLabel}
                        style={{
                          color: !this.state.Type.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                        id="select-region-label"
                      >
                        Deal Type:
                      </InputLabel>
                      <Select
                        data-test="Type"
                        value={this.state.Type}
                        onChange={this.handleChangeFilter}
                        name="Type"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters !== "" &&
                          this.props.funnelFilters.dealType.map((y) => (
                            <MenuItem key={y.Type} value={y.Type}>
                              {y.Type}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* {this.props.company !== "C0003" && (
            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={2}
              md={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={12} sm={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-Cust_Type-label"
                      style={{
                        color: !this.state.Cust_Type.includes("All")
                          ? "#4472c4"
                          : "#000",
                      }}
                    >
                      Customer Type:
                    </InputLabel>
                    <Select
                      labelId="select-Cust_Type-label"
                      id="select-Cust_Type"
                      value={this.state.Cust_Type}
                      onChange={this.handleChangeFilter}
                      name="Cust_Type"
                      data-test="Cust_Type"
                      multiple
                    >
                      <MenuItem value={"All"}>All</MenuItem>
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.cust_type
                          .map((f) => f.Cust_Type)
                          .sort()
                          .filter((item) => item !== "")
                          .map((y) => (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            )} */}

            <Grid
              container
              item
              style={{ padding: 10, paddingTop: 15 }}
              xs={3}
              sm={3}
              md={this.props.Value_Label.length > 5 ? 4 : 3} //3
              lg={this.props.Value_Label.length > 5 ? 3 : 2} //2
              xl={2}
            >
              <Grid
                item
                spacing={2}
                xs={12}
                container
                component={Paper}
                style={{ paddingTop: 8 }}
              >
                <Grid item xs={2} sm={12} style={{ paddingTop: 0 }}>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel
                      id="select-exclude-label"
                      style={{ color: "#4472c4", whiteSpace: "nowrap" }}
                    >
                      {`Excl. ${this.props.Value_Label} <0 (curr. & past):`}
                    </InputLabel>
                    <Select
                      data-test="Exclude_ACV"
                      labelId="Exclude_ACV-label"
                      id="IExclude_ACV"
                      value={this.state.exclude_acv_lte_zero}
                      onChange={this.handleExcludeACV}
                      label={`Excl. ${this.props.Value_Label} <=0 (curr. & past):`}
                      name="exclude_acv_lte_zero"
                    >
                      {this.props.funnelFilters !== "" &&
                        this.props.funnelFilters.includeCQWon
                          .filter((item) => item.INCLUDE_ALL_CQ_WON !== "")
                          .map((y) => (
                            <MenuItem
                              key={y.INCLUDE_ALL_CQ_WON}
                              value={y.INCLUDE_ALL_CQ_WON}
                            >
                              {y.INCLUDE_ALL_CQ_WON}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            {this.props.company === "C0021" && (
              <>
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <RegionFilter
                    classes={classes}
                    options={this.props.funnelFilters.Region__c}
                    value={this.state.Region__c}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                  />
                </Grid>

                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <OppSourceChannelFilterComponent
                    classes={classes}
                    options={
                      this.props.funnelFilters.Opportunity_Source_Channel__c
                    }
                    value={this.state.Opportunity_Source_Channel__c}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                  />
                </Grid>

                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <ChannelTypeFilterComponent
                    classes={classes}
                    options={this.props.funnelFilters.Channel_Type__c}
                    value={this.state.Channel_Type__c}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                    company={this.props.company}
                  />
                </Grid>
              </>
            )}

            {this.props.company === "C0022" && (
              <>
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <AccountTypeFilter
                    classes={classes}
                    options={this.props.funnelFilters.Acct_Type}
                    value={this.state.Acct_Type}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                  />
                </Grid>

                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <AccountEmpRangeFilter
                    classes={classes}
                    options={this.props.funnelFilters.Acct_Emp_Range}
                    value={this.state.Acct_Emp_Range}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                  />
                </Grid>
              </>
            )}

            {this.props.company === "C0023" && (
              <>
                <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <TransactionTypeFilter
                    classes={classes}
                    options={this.props.funnelFilters.Transaction_Type__c}
                    value={this.state.Transaction_Type__c}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                  />
                </Grid>

                 <Grid
                  container
                  item
                  style={{ padding: 10, paddingTop: 15 }}
                  xs={2}
                >
                  <ChannelTypeFilterComponent
                    classes={classes}
                    options={this.props.funnelFilters.Channel_Type__c}
                    value={this.state.Channel_Type__c}
                    onChange={this.handleChangeFilter}
                    paddingAvailable={true}
                    company={this.props.company}
                  />
                </Grid>
              </>
            )}

            {this.props.company === "C0027" && (
              <Grid container item style={{ padding: 10, paddingTop: 15 }} xs={2}>
                <Grid item spacing={2} xs={12} container component={Paper} style={{ paddingTop: 0 }}>
                  <Grid item xs={12} sm={12}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        className={classes.filterLabel}
                        style={{
                          color: !this.state.Product_Family.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                        id="select-Product_Family-last-label"
                      >
                        Product Family Contains:
                      </InputLabel>
                      <Select
                        value={this.state.Product_Family}
                        onChange={this.handleChangeFilter}
                        name="Product_Family"
                        data-test="Product_Family"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters !== "" &&
                          (this.props.funnelFilters?.Product_Family || [])
                            .map((t) => t.Product_Family)
                            .filter((item) => item !== "")
                            .map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {this.props.company === "C0027" && (
              <Grid container item style={{ padding: 10, paddingTop: 15 }} xs={2}>
                <Grid item spacing={2} xs={12} container component={Paper} style={{ paddingTop: 0 }}>
                  <Grid item xs={12} sm={12}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        className={classes.filterLabel}
                        style={{
                          color: !this.state.Region.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                        id="select-Region-label"
                      >
                        Account Region:
                      </InputLabel>
                      <Select
                        value={this.state.Region}
                        onChange={this.handleChangeFilter}
                        name="Region"
                        data-test="Region"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.funnelFilters !== "" &&
                          (this.props.funnelFilters?.Region || [])
                            .map((t) => t.Region)
                            .filter((item) => item !== "")
                            .map((y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </>
        ) : (
          <Grid
            item
            container
            component={Card}
            style={{ margin: "1rem" }}
            justify="center"
          >
            <Skeleton
              variant="react"
              animation="wave"
              height={120}
              width="90%"
              style={{ margin: "1rem" }}
            />
          </Grid>
        )}

        {this.props.funnelFilters ? (
          <Grid
            item
            xs={12}
            md={12}
            id="grid-container"
            style={{ marginTop: "1rem" }}
          >
            <Paper style={{ marginBottom: "-7px" }}>
              <ToggleButtonGroup
                color="primary"
                indicatorColor="primary"
                value={this.state.tab}
                exclusive
                size="large"
                onChange={this.handleChangeTab}
              >
                <ToggleButton
                  style={{
                    background: this.state.tab === "Summary" ? "#4472C4" : "",
                    color: this.state.tab === "Summary" ? "white" : "",
                    fontSize: "1rem",
                    fontWeight: 600,
                    height: "3.5rem",
                    width: "15rem",
                  }}
                  value="Summary"
                >
                  Summary
                </ToggleButton>
                <ToggleButton
                  style={{
                    background: this.state.tab === "Ensemble" ? "#4472C4" : "",
                    color: this.state.tab === "Ensemble" ? "white" : "",
                    fontSize: "1rem",
                    fontWeight: 600,
                    height: "3.5rem",
                    width: "15rem",
                  }}
                  value="Ensemble"
                >
                  Ensemble Model
                </ToggleButton>
              </ToggleButtonGroup>
            </Paper>
          </Grid>
        ) : (
          <Card style={{ margin: "auto", width: "100%" }} raised={true}>
            <Grid item container justify="center">
              <Skeleton
                variant="react"
                animation="wave"
                height={20}
                width="90%"
                style={{ margin: "1rem" }}
              />
            </Grid>
          </Card>
        )}

        {this.props.funnelData !== "" && this.props.funnelData.text ? (
          <Grid
            item
            xs={12}
            className={classes.grid}
            container
            justify="center"
            style={{ marginTop: "1rem" }}
          >
            <Grid
              item
              xs={12}
              style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
            >
              <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                {this.props.funnelData !== "" ? (
                  <Grid item container xs={12} justify="center">
                    <Typography
                      variant="h2"
                      style={{
                        margin: "1rem",
                        display: "flex",
                        justifyContent: "center",
                        padding: "1rem",
                      }}
                    >
                      Yield from Qualified pipeline at quarter start
                    </Typography>
                    <PipelineTable
                      winAcvData={[this.props.funnelData.text]}
                      splitType={"text"}
                      uniqueNames={["No Data Available"]}
                      Value_Label={this.props.Value_Label}
                    />
                  </Grid>
                ) : (
                  <Grid item container justify="center">
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                )}
              </Card>
            </Grid>
          </Grid>
        ) : this.state.tab === "Summary" ? (
          <>
            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                  {this.props.funnelData !== ""  ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <Typography
                        variant="h2"
                        style={{
                          width: "100%",
                          margin: "auto",
                          marginTop: "1rem",
                        }}
                        align="center"
                      >
                        Projection for {this.props.funnelData.fiscalQuarter}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          width: "100%",
                          margin: "auto",
                          "padding-bottom": "0.25rem",
                          paddingTop: "0.5rem",
                          fontWeight: 600,
                          // color: "grey",
                        }}
                        align="center"
                      >
                        <span
                          style={{ background: "#ffc000ff", padding: "0.3rem" }}
                        >
                          ({this.props.funnelData.quarterIndication})
                        </span>
                      </Typography>

                      <LowMIdHighTable
                        winAcvData={this.props.funnelData.expectedHighMidLow}
                        quarterLastDate={
                          this.props.funnelData.quarterIndication ===
                          "Next Quarter"
                            ? this.props.funnelData.currentDate
                            : this.props.funnelData.quarterLastDate
                        }
                        showDifference={this.props.funnelData.showDifference}
                        closedWonAfterOffset={
                          this.props.funnelData.closedWonAfterOffset
                        }
                        Value_Label={this.props.Value_Label}
                        emailName='Time_Series_Projection_Summary_table'
                        isShown={this.state.showEstimatedAdditionalPipeline}
                        onToggle={this.handleToggleEstimate}
                        showButton={true}
                        monthindication={this.props.funnelData.quarterIndication}
                      />
                      {this.props.funnelData.showActual && (
                        <Typography
                          variant="h2"
                          style={{
                            margin: "1rem",
                            display: "flex",
                            justifyContent: "center",
                            padding: "1rem",
                          }}
                        >
                          <span style={{ padding: "0.5rem" }}>Actual Won:</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <span
                            style={{
                              border: "1px solid green",
                              padding: "0.5rem",
                            }}
                          >
                            {countOrACVFormatter(
                              this.props.funnelData.closedWonACVInQuarter,
                              true
                            )}
                          </span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <span style={{ padding: "0.5rem" }}>
                            % of Midpoint:
                          </span>
                          &nbsp;
                          <span style={{ padding: "0.5rem" }}>
                            {Math.round(
                              this.props.funnelData.percOfTotal * 100
                            )}
                            %
                          </span>
                        </Typography>
                      )}

{
                        this.state.showEstimatedAdditionalPipeline &&
                        <>
                        <Typography
                        variant="h2"
                        style={{
                          width: "100%",
                          margin: "auto",
                          marginTop: "1rem",
                        }}
                        align="center"
                      >
                        Estimate Additional Qualified Pipeline needed
                      </Typography>


                      <AdditionalQualifiedPipelineNeeded 
                      projectedMidpoint={this.props.funnelData.expectedHighMidLow.filter(c => c.category === "Total").reduce((a,b) => a+b.mid, 0)}
                      initialGoal={this.props.funnelData.expectedHighMidLow.filter(c => c.category === "Total").reduce((a,b) => a+b.mid, 0)}
                      data={this.props.funnelData
                        .newQuaifiedPipeineCreatedVsWonData}
                        // converted={this.state.goalValue}
                        convertedrowOne={this.props.funnelData.expectedHighMidLow.filter(c => c.category === "B: Expected ACV to be Qualified and Closed Won").reduce((a,b) => a+b.mid, 0)}
                      />

                     
                        
                      </>

                    
                      }
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                  {this.props.funnelData !== "" ? (
                    this.props.funnelData.quarterIndication ===
                    "Next Quarter" ? (
                      <Grid container style={{ paddingBottom: "3rem" }}>
                        <Grid xs={1} align="center"></Grid>
                        <Grid xs={5} align="center">
                          <Typography
                            variant="h2"
                            style={{
                              margin: "1rem",
                              display: "flex",
                              justifyContent: "center",
                              padding: "1rem",
                              paddingBottom: "0rem",
                              marginBottom: "0rem",
                            }}
                          >{`Qualified Pipeline ${this.props.funnelData.nfq} - Current`}</Typography>
                          <PipelineTable
                            winAcvData={this.props.funnelData.qualifiedPipeline}
                            splitType={this.props.funnelData.splitType}
                            uniqueNames={this.props.funnelData.uniqueNames}
                            Value_Label={this.props.Value_Label}
                            // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                            firstCell="count"
                            secondCell="acv"
                            thirdCell="perc"
                            tableHeader="Qualified Pipeline"
                            drilldownHeader="Qualified Pipeline"
                            cellHeader1="Opps"
                            cellHeader2={`${this.props.Value_Label}`}
                            cellHeader3="% of Tot."
                            key1="Projectedv2"
                            key2="Projectedv2"
                            handleChangeLocation={this.handleChangeLocation}
                            dataTest={"qualified-pipeline-at-start"}
                            tableHeader1={
                              this.props.funnelData.offsetDaysNew
                                ? `As of day ${this.props.funnelData.offsetDaysNew}`
                                : ""
                            }
                          />
                        </Grid>

                        <Grid xs={5} align="center">
                          <Typography
                            variant="h2"
                            style={{
                              margin: "1rem",
                              display: "flex",
                              justifyContent: "center",
                              padding: "1rem",
                              paddingBottom: "0rem",
                              marginBottom: "0rem",
                            }}
                          >{`Qualified Pipeline - projected for ${this.props.funnelData.nfq} at start of ${this.props.funnelData.nfq}`}</Typography>
                          <PipelineTablev2
                            winAcvData={
                              this.props.funnelData
                                .nextQuarterProjectedQPAtNextQuarterStartLMH
                            }
                            splitType={this.props.funnelData.splitType}
                            uniqueNames={this.props.funnelData.uniqueNames}
                            Value_Label={this.props.Value_Label}
                            // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                            firstCell="low"
                            secondCell="mid"
                            thirdCell="high"
                            tableHeader="Qualified Pipeline"
                            drilldownHeader="Qualified Pipeline"
                            cellHeader1="Low"
                            cellHeader2="Mid"
                            cellHeader3="High"
                            key1="Projected"
                            key2="Projected"
                            // handleChangeLocation={this.handleChangeLocation}
                            dataTest={"qualified-pipeline-projected"}
                            tableHeader1={
                              this.props.funnelData.quarterLastDate
                                ? `As of ${dateFormatterMomentV4(
                                    this.props.funnelData.quarterLastDate
                                  )}`
                                : ""
                            }
                          />
                        </Grid>
                        <Grid xs={1} align="center"></Grid>
                      </Grid>
                    ) : (
                      <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                        <Typography
                          variant="h2"
                          style={{
                            margin: "1rem",
                            display: "flex",
                            justifyContent: "center",
                            padding: "1rem",
                          }}
                        >
                          {this.props.funnelData.quarterIndication ===
                          "Next Quarter"
                            ? `Qualified Pipeline - projected for ${this.props.funnelData.nfq} at start of ${this.props.funnelData.nfq}`
                            : `Qualified Pipeline`}
                        </Typography>
                        <PipelineTable
                          winAcvData={this.props.funnelData.qualifiedPipeline}
                          splitType={this.props.funnelData.splitType}
                          uniqueNames={this.props.funnelData.uniqueNames}
                          Value_Label={this.props.Value_Label}
                          // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                          firstCell="count"
                          secondCell="acv"
                          thirdCell="perc"
                          tableHeader="Qualified Pipeline"
                          drilldownHeader="Qualified Pipeline"
                          cellHeader1="Opps"
                          cellHeader2={`${this.props.Value_Label}`}
                          cellHeader3="% of Tot."
                          key1="Projected"
                          key2="Projected"
                          handleChangeLocation={this.handleChangeLocation}
                          dataTest={"qualified-pipeline"}
                          tableHeader1={
                            this.props.funnelData.quarterLastDate
                              ? `As of ${dateFormatterMomentV4(
                                  this.props.funnelData.quarterLastDate
                                )}`
                              : ""
                          }
                        />
                      </Grid>
                    )
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>

            {this.props.funnelData.quarterIndication === "Next Quarter" && (
              <Grid
                item
                xs={12}
                className={classes.grid}
                container
                justify="center"
                style={{ marginTop: "1rem" }}
              >
                <Grid
                  item
                  xs={12}
                  style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
                >
                  <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                    {this.props.funnelData !== "" ? (
                      <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                        <Typography
                          variant="h2"
                          style={{
                            margin: "1rem",
                            display: "flex",
                            justifyContent: "center",
                            padding: "1rem",
                          }}
                        >
                          Projecting the Qualified pipeline for the next quarter
                          at the start of the next quarter
                        </Typography>
                        <PipelineTable
                          winAcvData={this.props.funnelData.projectPipelineForNextQuarterData.filter(
                            (f) =>
                              f[this.props.funnelData.splitType] === "Total"
                          )}
                          splitType={this.props.funnelData.splitType}
                          uniqueNames={["Total"]}
                          uniqueStages={this.props.funnelData.uniqueNames.filter(
                            (f) => f !== "Total"
                          )}
                          Value_Label={this.props.Value_Label}
                          // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                          firstCell="atTheTimeACV"
                          secondCell="endACV"
                          thirdCell="changePerc"
                          tableHeader="Stage at Time "
                          drilldownHeader="Projecting the Qualified pipeline for the next quarter at the start of the next quarter"
                          // cellHeader1="Projected"
                          cellHeader1="Pipeline for next qtr."
                          // cellHeader2="Actual"
                          cellHeader2="Pipeline for next qtr. at next qtr. start"
                          key1="Start"
                          key2="End"
                          cellHeader3="% Change"
                          handleChangeLocation={this.handleChangeLocation}
                          dataTest={"Pipeline-for-next-qtr"}
                          tableHeader1={
                            this.props.funnelData.offsetDaysNew
                              ? `As of Day ${this.props.funnelData.offsetDaysNew}`
                              : ""
                          }
                        />

                        <PipelineTable
                          winAcvData={
                            this.props.funnelData
                              .projectPipelineForNextQuarterPerTotal
                          }
                          splitType={this.props.funnelData.splitType}
                          uniqueNames={this.props.funnelData.uniqueNames}
                          Value_Label={this.props.Value_Label}
                          // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                          firstCell="count"
                          secondCell="endACV"
                          thirdCell="convPerc"
                          tableHeader="Stage at Time"
                          drilldownHeader="Projecting the Qualified pipeline for the next quarter at the start of the next quarter"
                          // cellHeader1="Projected"
                          cellHeader1="# of Opps"
                          // cellHeader2="Actual"
                          cellHeader2="Pipeline for next qtr. at next qtr. start"
                          key1="End"
                          key2="End"
                          cellHeader3="% of Total"
                          handleChangeLocation={this.handleChangeLocation}
                          dataTest={"Pipeline-for-next-qtr-nextqtr-start"}
                          tableHeader1={
                            this.props.funnelData.offsetDaysNew
                              ? `As of Day ${this.props.funnelData.offsetDaysNew}`
                              : ""
                          }
                        />
                      </Grid>
                    ) : (
                      <Grid item container justify="center">
                        <Skeleton
                          variant="react"
                          animation="wave"
                          height={120}
                          width="90%"
                          style={{ margin: "1rem" }}
                        />
                      </Grid>
                    )}
                  </Card>
                </Grid>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                  {this.props.funnelData !== "" ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between", // Ensures spacing between the title and the button
                          alignItems: "center", // Aligns items vertically in the center
                          width: "100%",
                          marginRight: "5%",
                        }}
                      >
                        <Typography
                          variant="h2"
                          style={{
                            margin: "1rem",
                            textAlign: "center",
                            flex: 1,
                          }}
                        >
                          Linearity
                        </Typography>
                        <div style={{ flexShrink: 0, marginRight: 10 }}>
                          <ExportPPtx
                            chartRef={this.chartRef}
                            title={"Linearity"}
                          />
                        </div>
                      </div>
                      <Grid ref={this.chartRef}>
                        {
                          this.props.funnelData.showQuota ? 
                          <VerticalStackedBarChart
                          data={this.props.funnelData.linearity.map((f) => {
                            return {
                              Category: f.quarter,
                              type1: f.quota,
                              type2: 0,
                              type3: f.wonAsOfCuurentDayOfQuarter,
                              type4: f.totalACVLOW,
                              type5: f.totalACV,
                              type6: f.totalACVHIGH,
                              type7: f.qualifiedACV,
                            };
                          })}
                          lowMidHigh={this.props.funnelData.expectedHighMidLow.filter(
                            (f) => f.category === "Total"
                          )}
                        /> :
                        <VerticalStackedBarChartWithoutQuota
                          data={this.props.funnelData.linearity.map((f) => {
                            return {
                              Category: f.quarter,
                              type1: 0,
                              type2: 0,
                              type3: f.wonAsOfCuurentDayOfQuarter,
                              type4: f.totalACVLOW,
                              type5: f.totalACV,
                              type6: f.totalACVHIGH,
                              type7: f.qualifiedACV,
                            };
                          })}
                          lowMidHigh={this.props.funnelData.expectedHighMidLow.filter(
                            (f) => f.category === "Total"
                          )}
                        />
                        }
                       
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                  {this.props.funnelData !== "" ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <Typography
                        variant="h2"
                        style={{
                          margin: "1rem",
                          display: "flex",
                          justifyContent: "center",
                          padding: "1rem",
                        }}
                      >
                        Source of Qualified pipe that went to Won
                      </Typography>
                      <PipelineTable
                        winAcvData={this.props.funnelData.combinedData}
                        Value_Label={this.props.Value_Label}
                        splitType={this.props.funnelData.splitType}
                        uniqueNames={this.props.funnelData.uniqueStrings}
                        uniqueStages={this.props.funnelData.uniqueNames.filter(
                          (c) => c !== "Total"
                        )}
                        firstCell="count"
                        secondCell="acv"
                        thirdCell="perc"
                        drilldownHeader="Summary view of Source of Qualified pipe"
                        tableHeader="Source of Qualified pipe"
                        cellHeader1="Opps"
                        cellHeader2={`${this.props.Value_Label}`}
                        cellHeader3="% of Total"
                        handleChangeLocation={this.handleChangeLocation}
                        disableColumnTotal={true}
                        dataTest={"Source-of-Qualified-pipe"}
                        alphabetRequired={true}
                        tableHeader1={
                          this.props.funnelData.quarterLastDate
                            ? `As of Day ${this.props.funnelData.offsetDays}`
                            : ""
                        }
                        // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                      />
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={false}>
                  {this.props.funnelData !== "" ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <Typography
                        variant="h2"
                        style={{
                          margin: "1rem",
                          display: "flex",
                          justifyContent: "center",
                          padding: "1rem",
                        }}
                      >
                        A: What was qualified and above and projected to be Won
                        vs. what was Won
                      </Typography>
                      <PipelineTable
                        winAcvData={this.props.funnelData.qualifiedAndPrjData}
                        splitType={this.props.funnelData.splitType}
                        uniqueNames={this.props.funnelData.uniqueNames}
                        Value_Label={this.props.Value_Label}
                        // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                        firstCell="projectedACV"
                        secondCell="actualACV"
                        thirdCell="convPerc"
                        tableHeader="Stage at Time"
                        drilldownHeader="What was qualified and above and projected to be Won vs. what was Won"
                        // cellHeader1="Projected"
                        cellHeader1="In Pipeline"
                        // cellHeader2="Actual"
                        cellHeader2="Converted"
                        key1="Projected"
                        key2="Actual"
                        cellHeader3="% Conv."
                        handleChangeLocation={this.handleChangeLocation}
                        dataTest={"Stage-at-quarter-start"}
                        tableHeader1={
                          this.props.funnelData.quarterLastDate
                            ? `As of Day ${this.props.funnelData.offsetDays}`
                            : ""
                        }
                      />
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={false}>
                  {this.props.funnelData !== "" ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <Typography
                        variant="h2"
                        style={{
                          margin: "1rem",
                          display: "flex",
                          justifyContent: "center",
                          padding: "1rem",
                        }}
                      >
                        B: What was Qualified in the qtr. and what was Won
                        within the qtr.
                      </Typography>
                      <PipelineTable
                        winAcvData={
                          this.props.funnelData
                            .newQuaifiedPipeineCreatedVsWonData
                        }
                        splitType={this.props.funnelData.splitType}
                        uniqueNames={
                          this.props.funnelData
                            .newQuaifiedPipeineCreatedVsWonString
                        }
                        uniqueStages={this.props.funnelData.uniqueNames.filter(
                          (c) => c !== "Total"
                        )}
                        Value_Label={this.props.Value_Label}
                        firstCell="createdACV"
                        secondCell="actualACV"
                        thirdCell="convPerc"
                        tableHeader=" "
                        drilldownHeader="What was Qualified in the qtr. and what was Won within the qtr."
                        cellHeader1="Created"
                        // cellHeader2="Won"
                        cellHeader2="Converted"
                        key2="Won"
                        cellHeader3="% Conv."
                        handleChangeLocation={this.handleChangeLocation}
                        dataTest={"qualified-in-quarter"}
                        tableHeader1={
                          this.props.funnelData.quarterLastDate
                            ? `From Day ${this.props.funnelData.offsetDays}`
                            : ""
                        }
                        // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                      />
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={false}>
                  {this.props.funnelData !== "" ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <Typography
                        variant="h2"
                        style={{
                          margin: "1rem",
                          display: "flex",
                          justifyContent: "center",
                          padding: "1rem",
                        }}
                      >
                        C. What was available qualified or later with projected
                        close date NOT in qtr. and what was Won (Typically
                        pulled in)
                      </Typography>
                      <PipelineTable
                        winAcvData={
                          this.props.funnelData.availableVsPulledinData
                        }
                        splitType={this.props.funnelData.splitType}
                        uniqueNames={[
                          this.props.funnelData.availableVsPulledinDataString,
                        ]}
                        uniqueStages={this.props.funnelData.uniqueNames.filter(
                          (c) => c !== "Total"
                        )}
                        Value_Label={this.props.Value_Label}
                        firstCell="availableACV"
                        secondCell="pulledinACV"
                        thirdCell="convPerc"
                        tableHeader=" "
                        drilldownHeader="What was Available Qualified pipe vs  Won from Opps qualified or later "
                        cellHeader1="Available"
                        // cellHeader2="Pulled In"
                        cellHeader2="Converted"
                        cellHeader3="% Conv."
                        key2="PCDNotin"
                        key1="Available"
                        handleChangeLocation={this.handleChangeLocation}
                        dataTest={"PCDNotin-Available"}
                        tableHeader1={
                          this.props.funnelData.quarterLastDate
                            ? `As of Day ${this.props.funnelData.offsetDays}`
                            : ""
                        }
                        // averageDevaitionCalculation={this.props.funnelData.averageDevaitionCalculation}
                      />
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid
              item
              xs={12}
              className={classes.grid}
              container
              justify="center"
              style={{ marginTop: "1rem" }}
            >
              <Grid
                item
                xs={12}
                style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
              >
                <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                  {this.props.funnelData !== "" &&
                  this.props.PipelineCoverageCFQ !== "" ? (
                    <Grid style={{ padding: "0.5rem 0.5rem" }} align="center">
                      <Typography
                        variant="h2"
                        style={{
                          margin: "1rem",
                          display: "flex",
                          justifyContent: "center",
                          padding: "1rem",
                        }}
                      >
                        Ensemble Model
                      </Typography>
                      <EnsembleModelTable
                        topDownData={this.props.funnelData.expectedHighMidLow.filter(
                          (f) => f.category === "Total"
                        )}
                        quarterLastDate={this.props.funnelData.quarterLastDate}
                        bottomUpData={this.props.PipelineCoverageCFQ.data.filter(
                          (f) => ["company", "team"].includes(f.name)
                        )}
                        showDifference={this.props.funnelData.showDifference}
                        closedWonAfterOffset={
                          this.props.funnelData.closedWonAfterOffset
                        }
                      />
                    </Grid>
                  ) : (
                    <Grid item container justify="center">
                      <Skeleton
                        variant="react"
                        animation="wave"
                        height={120}
                        width="90%"
                        style={{ margin: "1rem" }}
                      />
                    </Grid>
                  )}
                </Card>
              </Grid>
            </Grid>
          </>
        )}

        {this.state.location === "drilldownOnGraph" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={this.state.header}
              back={this.handleChangeLocationBack}
              filters={this.state.filtersForDrilldown}
            >
              <Drilldown
                header={this.state.header}
                body={this.props.drilldownOnGraphData}
                company={this.props.company}
                acvName={
                  this.state.drildownACVName === "Projected" ||
                  this.state.drildownACVName === "Available"
                    ? `${this.props.Value_Label} Then`
                    : `${this.props.Value_Label}`
                }
                handleSecondLevelDrilldown={this.handleSecondLevelDrilldown}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
        {this.state.secondLevelLocation === "drilldownOppId" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={"Opportunity Change Events"}
              back={this.handleChangeLocationBack}
              stepBack={this.stepBack}
              filters={[]}
            >
              <ExpectedAcvPage
                body={this.props.ExpectedAcvData}
                Value_Label={this.props.Value_Label}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
      </Grid>
    );
  }
}

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      // prefix="$"
      allowNegative={false}
    />
  );
}

function mapStateToProps(state) {
  const {
    funnelFilters,
    funnelData,
    persistentAlert,
    user,
    drilldownOnGraphData,
    updatingFunnelData,
    updatingDrillDownData,
    currentFilters,
    ExpectedAcvData,
    PipelineCoverageCFQ,
  } = state.app;

  return {
    PipelineCoverageCFQ,
    funnelFilters,
    funnelData,
    persistentAlert,
    company: user.company,
    Value_Label: user.Value_Label,
    Currency_Symbol: user.Currency,
    drilldownOnGraphData,
    updatingFunnelData,
    updatingDrillDownData,
    currentFilters,
    ExpectedAcvData,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
}

const mapDispatchToProps = (dispatch) => ({
    clearVariables:()=>{
    dispatch({type:"clear_variables"})
  },
  getFunnelFilters: (company) => {
    dispatch({ type: "get_funnel_filters_request" });
    appService.getTimeSeriesPredictionv2Filters().then(
      (json) => {
        dispatch({ type: "get_funnel_filters_success", json });
        dispatch({ type: "get_funnel_data_request" });
        dispatch({ type: `get_generic_pipeline_coverage_data_CFQ_request` });
        const defaultFiscalQuarter = getDefaultSelectedFiscalQuarters(
          json.message.fiscalQuarters,
          "fiscal_quarter"
        );
        let filters = [];
        const defaultDays = json.message.defaultOffsetDays;
        if (defaultFiscalQuarter.length > 0) {
          filters = [{ name: "fiscal_quarter", value: defaultFiscalQuarter }];
        }

        if (defaultDays) {
          filters = [...filters, { name: "offset_days", value: defaultDays }];
        }
        filters = [...filters, { name: "lookback_quarter", value: 4 }];
        const excludLargeDeals =
          getDefaultSalesType(
            json.message.exclude_large_deals,
            "exclude_large_deals"
          )[0] === "All"
            ? "No"
            : getDefaultSalesType(
                json.message.exclude_large_deals,
                "exclude_large_deals"
              )[0];
        const incluAllCq =
          getDefaultSalesType(
            json.message.includeCQWon,
            "INCLUDE_ALL_CQ_WON"
          )[0] === "All"
            ? "No"
            : getDefaultSalesType(
                json.message.includeCQWon,
                "INCLUDE_ALL_CQ_WON"
              )[0];

        const excludeACVLTEZ =
          getDefaultSalesType(
            json.message.exclude_acv_lte_zero,
            "exclude_acv_lte_zero"
          )[0] === "All"
            ? "No"
            : getDefaultSalesType(
                json.message.exclude_acv_lte_zero,
                "exclude_acv_lte_zero"
              )[0];
        // console.log(excludLargeDeals)
        filters = [
          ...filters,
          { name: "INCLUDE_ALL_CQ_WON", value: incluAllCq },
          { name: "exclude_acv_lte_zero", value: excludeACVLTEZ },
        ];
         
        // Adding Team filter default value if exists
        if(json.message.parentChildrenTeamFilter){
         
          const teamFilter = json.message.parentChildrenTeamFilter.defaultValueTeam;
        
          if(teamFilter && teamFilter.length > 0 && teamFilter[0].toLowerCase() !== "all"){
            filters = [...filters, { name: "team", value: teamFilter }];
          }
        }

        if(["C0024", "C0027"].includes(company)){
          const productFamily = getDefaultSalesType(
                    json.message.Product_Family,
                    "Product_Family"
                  );
          // const productFamily = getDefaultSelectedProductFamily(json.message.Product_Family);
          if(productFamily[0] !== null && productFamily[0] !== "All"){
            filters = [...filters, { name: "Product_Family", value: productFamily }];
          } 
          
        }
        if (excludLargeDeals === "Yes") {
          const thresholdFilters = getDefaultThreshold(
            json.message.large_deal_threshold
          );
          filters = [
            ...filters,
            { name: "threshold", value: thresholdFilters },
          ];
        }
        // const xyAxis=json.message.Dimensions.filter(i=>i.type === 'Ch_Opp_Column_Name')
        // const primary=xyAxis.filter(i=>i.default_axis === 'y')[0].Ch_Opp_Column_Name
        // const secondary=xyAxis.filter(i=>i.default_axis === 'x')[0].Ch_Opp_Column_Name
        dispatch({ type: "current_selected_filters", filters });

        appService.getTimeSeriesPredictionv2Data(filters).then(
          (json) => {
            dispatch({ type: "get_funnel_data_success", json });
          },
          (error) => {
            if (typeof error === "object")
              dispatch({
                type: "get_funnel_data_failure",
                error: "Something went wrong",
              });
            else dispatch({ type: "get_funnel_data_failure", error });
          }
        );

        appService.getGenericPipelineCoverageData([], "CFQ").then(
          (json) => {
            dispatch({
              type: `get_generic_pipeline_coverage_data_CFQ_success`,
              json,
            });
          },
          (error) => {
            if (typeof error === "object")
              dispatch({
                type: `get_generic_pipeline_coverage_data_CFQ_failure`,
                error: "Something went wrong",
              });
            else dispatch({ type: "get_quota_attainment_data_failure", error });
          }
        );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnel_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnel_filters_failure", error });
      }
    );
  },
  getFunnelDataNew: (filters, primary, secondary) => {
    dispatch({ type: "get_funnel_data_request" });
    dispatch({ type: "current_selected_filters", filters });
    appService.getTimeSeriesPredictionv2Data(filters).then(
      (json) => {
        dispatch({ type: "get_funnel_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnel_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnel_data_failure", error });
      }
    );
  },
  getPipelineCoverageData: (filters) => {
    dispatch({ type: `get_generic_pipeline_coverage_data_CFQ_request` });
    appService.getGenericPipelineCoverageData(filters, "CFQ").then(
      (json) => {
        dispatch({
          type: `get_generic_pipeline_coverage_data_CFQ_success`,
          json,
        });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: `get_generic_pipeline_coverage_data_CFQ_failure`,
            error: "Something went wrong",
          });
        else dispatch({ type: "get_quota_attainment_data_failure", error });
      }
    );
  },
  getConversionEffecienceyDrilldown: (filters, key) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getConversionEffecienceyDrilldownv2(filters, key).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].map(
          (item, index) => {
            let x = {
              ...item,
              OppNo: index + 1,
            };
            return x;
          }
        );

        tempOpportunities.sort((a, b) => (a.ACV > b.ACV ? -1 : 1));

        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
            columns: json.message.columns,
          },
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => {
    dispatch({ type: "clear_drilldown_data" });
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f5f5",
    },
  },
}))(TableRow);

const connectedTimeSeriesPredictionv2 = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TimeSeriesPredictionv2));
export { connectedTimeSeriesPredictionv2 as TimeSeriesPredictionv2 };
